<template>
  <div class="dev-space">
    <div class="content">
      <form-box
          title="My title"
          :fields="fields"
      ></form-box>
    </div>
  </div>
</template>

<script>
import FormBox from "@/InputControls/FormBox";

export default {
  name: "DevSpace",
  components: {FormBox},
  data() {
    return {
      fields: [
        {
          "field_id": "object1",
          "field_name": "Item",
          "is_compulsory": false,
          "data_type": "text"
        },
        {
          "field_id": "object2",
          "field_name": "Original Allocation",
          "unit": "currency",
          "is_compulsory": true,
          "data_type": "decimal",
          "data_format": "[0-9]{1,3}(,[0-9]{3})*(\\.[0-9]+)?( million|billion)?"
        },
        {
          "field_id": "object3",
          "field_name": "Revised Allocation",
          "unit": "currency",
          "is_compulsory": true,
          "data_type": "decimal",
          "data_format": "[0-9]{1,3}(,[0-9]{3})*(\\.[0-9]+)?( million|billion)?",
          "math_formula": "fobject4+fobject5",
          "validation": {
            "strict_validation": {
              "larger_eq": 0
            }
          }
        },
        {
          "field_id": "object4",
          "field_name": "New Allocation",
          "unit": "currency",
          "is_compulsory": false,
          "data_type": "decimal",
          "data_format": "[0-9]{1,3}(,[0-9]{3})*(\\.[0-9]+)?( million|billion)?",
          "validation": {
            "strict_validation": {
              "larger_eq": 0
            }
          }
        },
        {
          "field_id": "object5",
          "field_name": "Utilisation as at the date of this announcement",
          "unit": "currency",
          "is_compulsory": false,
          "data_type": "decimal",
          "data_format": "[0-9]{1,3}(,[0-9]{3})*(\\.[0-9]+)?( million|billion)?",
          "validation": {
            "strict_validation": {
              "larger_eq": 0
            }
          }
        }
      ],
    }
  },
}
</script>

<style scoped lang="scss">
.dev-space {
  height: 100%;
  //background-color: white;
  padding: 3rem;
  display: flex;
  justify-content: center;

  .content {
    display: inline-block;
    margin-top: 100px;
  }
}

.content {

}
</style>
